<template>
    <app-layout>
        <template #header>
            <flash-messages />
            <AppHead title="Dashboard" />
        </template>

        <div class="col-12 col-lg-6 col-xl-4 px-0 my-3">
            <card icon="fas fa-user" :title="`${user.first_name} ${user.last_name}`" headerStyle="primary">
                <ul class="list-unstyled">
                    <li class="px-2 py-1 d-flex justify-content-between flex-column flex-md-row">
                        <strong>Account Balance</strong> <span class="text-secondary">{{ formatDollars(balance) }}</span>
                    </li>
                    <li class="px-2 py-1 d-flex justify-content-between flex-column flex-md-row">
                        <strong>Next Payment</strong> <span class="text-secondary">
                            {{ nextPayment().format('dddd, MMMM D YYYY') }}
                        </span>
                    </li>
                </ul>

                <div class="row mt-3" v-if="balance > 0">
                    <div class="col-sm-12">
                        <inertia-link :href="route('tu.balancepayment', user)">
                            <jet-button icon="fas fa-dollar-sign">Make Payment</jet-button>
                        </inertia-link>
                    </div>
                </div>
            </card>
        </div>

        <section v-if="orders" class="mt-4 mt-lg-5">
            <h3 class="mb-3"><i class="fas fa-boxes mr-3 fa-lg text-secondary"></i>Recent Orders</h3>

            <DataTable :value="orders" :rowClass="() => { return 'table-row' }" breakpoint="992px" stripedRows
                id="dashboardTable" class="p-datatable-sm" tableClass="border-left border-right border-bottom"
                @row-click="(e) => showOrderDetail(e.data)">
                <Column field="id" header="ID" headerStyle="width: 20%">
                    <template #body="slotProps">
                        {{ slotProps.data.id }}
                        <PaymentInfo class="ml-2" :item="slotProps.data" />
                    </template>
                </Column>
                <Column headerStyle="width: 20%" field="status_desc" header="Status"></Column>
                <Column headerStyle="width: 20%" field="total" header="Total">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.total) }}
                    </template>
                </Column>
                <Column headerStyle="width: 40%" field="date" header="Date">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
                    </template>
                </Column>
            </DataTable>

            <div class="mt-2">
                <inertia-link class="px-0" :href="route('orders.list')" tabindex="-1">
                    View All
                </inertia-link>
            </div>
        </section>

        <section v-if="$page.props.payments" class="mt-4 mt-lg-5">
            <h3 class="mb-3"><i class="fas fa-dollar-sign mr-3 fa-lg text-secondary"></i>Recent Payments</h3>
            <DataTable :value="$page.props.payments" :rowClass="() => { return 'table-row' }" breakpoint="992px" stripedRows
                id="paymentsTable" class="p-datatable-sm" tableClass="border-left border-right border-bottom"
                @row-click="e => openPrintPaymentReceipt(e.data.id)">
                <Column field="transaction_date" header="Date">
                    <template #body="slotProps">
                        <span v-if="slotProps.data.transaction_date">
                            {{ moment(slotProps.data.transaction_date).format('M/D/YY h:mm A') }}
                        </span>
                    </template>
                </Column>
                <Column field="id" header="Payment">
                    <template #body="slotProps">
                        <PaymentType class="ml-2" :payment="slotProps.data" />
                    </template>
                </Column>
                <Column field="amount" header="Amount">
                    <template #body="slotProps">
                        {{ formatDollars(slotProps.data.amount) }}
                    </template>
                </Column>
            </DataTable>

            <div class="mt-2">
                <inertia-link class="px-0" :href="route('payments.list')" tabindex="-1">
                    View All
                </inertia-link>
            </div>
        </section>

        <Notes :notes="notes" :writeNotes="false" />
    </app-layout>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="printPaymentReceipt" />
    </teleport>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import Notes from '@/Shared/Notes'
import moment from 'moment'
import PaymentType from '@/Components/Transaction/PaymentType'
import PrintModal from '@/Components/Modals/PrintModal'

export default {
    components: {
        AppLayout,
        FlashMessages,
        Icon,
        Notes,
        PaymentType,
        PrintModal,
    },
    props: {
        products: Array,
        user: Object,
        orders: Array,
        balance: Number,
        total_orders: Number,
        notes: Array
    },
    data() {
        return {
            currentDate: moment(),
            formNote: this.$inertia.form({
                _method: 'put',
                content: null
            }),
            selectedReceiptPaymentId: null,
            printUrl: '',
        }
    },
    created() {
        this.moment = moment;
    },
    methods: {
        showOrderDetail(order) {
            this.$inertia.visit(this.route('order.view', order));
        },
        nextPayment() {
            let currentDate = moment().startOf('day');
            let next = currentDate.clone().startOf('week');
            next.add(this.user.payment_day_of_week, 'd');
            if (next.isBefore(currentDate)) {
                next.add(7, 'd');
            }

            return next;
        },
        openPrintPaymentReceipt(paymentId) {
            this.selectedReceiptPaymentId = paymentId
            this.printUrl = this.route('tu.payment.receipt', this.selectedReceiptPaymentId);
            $('#PrintModal').modal('show');
        },
        printPaymentReceipt() {
            this.printUrl = this.route('tu.payment.receipt', { payment: this.selectedReceiptPaymentId, print: 1 });
        },
    },
}
</script>

<style>
.table-row {
    cursor: pointer;
}
</style>
